const printEditor = {
    namespaced: true,
    state: {
        configurationList: [],
        stopList: [],
        logoList: [],
        stopTimetables: []
    },
    mutations: {
        updateConfigurationList(state, newList) {
            state.configurationList = newList;
        },
        updateStopList(state, newList) {
            state.stopList = newList;
        },
        updateLogoData(state, newList) {
            state.logoList = newList;
        },
        updateStopTimetables(state, newList) {
            state.stopTimetables = newList;
        }
    },
    actions: {
        getConfigurationList(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/timetables/printeditor/getConfigurations')
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateConfigurationList', response.data);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        getStopList(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/timetables/printeditor/getStops')
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateStopList', response.data);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        getLogoData(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/timetables/printeditor/getLogoData')
                    .then(response => {
                        if (response.status == 200) {
                            context.commit('updateLogoData', response.data);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        },
        getStopTimetable(context, parameters) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/timetables/printeditor/getPrintTimetable', { params: parameters })
                    .then(response => {
                        if (response.status == 200) {
                            let newList = [ ...context.state.stopTimetables, response.data ];
                            context.commit('updateStopTimetables', newList);
                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            });
        }
    }
}
export default printEditor;